import { restGet } from "apiCommandsExecutor/rest";

import { TariffOptionDto } from "./restModels";

export const getTariffOptions = () => restGet<TariffOptionDto[]>("/tariffs");
